import { Chip, Table } from '@heroui/react'

import { RowActions } from '@/components/ui/row-actions'
import { translated } from '@/lib/api/common'

import type { TenantBranch } from '../types'

export type BranchRowAction = 'edit' | 'enable' | 'disable' | 'delete'

interface BranchesTableProps {
  branches: TenantBranch[]
  onAction: (action: BranchRowAction, branch: TenantBranch) => void
  busyIds: string[]
}

/** `08:00 – 22:00`, or a dash when the branch defers to the weekly hours. */
function tradingWindow(branch: TenantBranch): string {
  if (!branch.openHour || !branch.closeHour) return '—'
  return `${branch.openHour} – ${branch.closeHour}`
}

export function BranchesTable({ branches, onAction, busyIds }: BranchesTableProps) {
  return (
    <Table>
      <Table.ScrollContainer>
        <Table.Content aria-label="Branches">
          <Table.Header>
            <Table.Column id="name" isRowHeader>
              Branch
            </Table.Column>
            <Table.Column id="address">Address</Table.Column>
            <Table.Column id="hours">Hours</Table.Column>
            <Table.Column id="status">Status</Table.Column>
            <Table.Column id="actions">
              <span className="sr-only">Actions</span>
            </Table.Column>
          </Table.Header>

          <Table.Body>
            {branches.map((branch) => (
              <Table.Row key={branch.id} id={branch.id}>
                <Table.Cell>
                  <span className="font-medium">{translated(branch.name, 'Unnamed branch')}</span>
                </Table.Cell>

                <Table.Cell>
                  <span className="text-muted text-sm">{translated(branch.address, '—')}</span>
                </Table.Cell>

                <Table.Cell>
                  <span className="text-muted text-sm tabular-nums">{tradingWindow(branch)}</span>
                </Table.Cell>

                <Table.Cell>
                  <Chip size="sm" variant="soft" color={branch.enabled ? 'success' : 'default'}>
                    {branch.enabled ? 'Open' : 'Closed'}
                  </Chip>
                </Table.Cell>

                <Table.Cell>
                  <RowActions
                    label={translated(branch.name, 'this branch')}
                    isBusy={busyIds.includes(branch.id)}
                    onAction={(id) => onAction(id as BranchRowAction, branch)}
                    actions={[
                      { id: 'edit', label: 'Edit' },
                      branch.enabled
                        ? { id: 'disable', label: 'Close branch' }
                        : { id: 'enable', label: 'Open branch' },
                      { id: 'delete', label: 'Delete' },
                    ]}
                  />
                </Table.Cell>
              </Table.Row>
            ))}
          </Table.Body>
        </Table.Content>
      </Table.ScrollContainer>
    </Table>
  )
}
